import mapperIcon from '../../../data-layer/utils/mappers/mapper-icon'
import type { GlobalDataBusinessType, GlobalDataBusinessTypeResponse } from '../../../types/mappers'

/**
 * globalDataBusinessType
 * @param {Object} data - cms response data
 * @return {Object} the normalized data
 */
export const mapperGlobalDataBusinessType = (data: GlobalDataBusinessTypeResponse): GlobalDataBusinessType | null => {
  if (!data) {
    return null
  }
  return {
    id: data?.sys?.id || '',
    name: data?.name || '',
    icon: mapperIcon(data?.icon)
  }
}
